import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconPasswordHide = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.9997 15.5456C7.07879 15.5456 3.7545 12.7127 2.0498 11.0441C1.38031 10.3887 1.40337 9.33974 2.10227 8.71588C3.82203 7.18078 7.10847 4.63647 9.9997 4.63647C12.891 4.63647 16.1773 7.18078 17.8972 8.71588C18.5961 9.33974 18.6191 10.3887 17.9496 11.0441C16.2449 12.7127 12.9206 15.5456 9.9997 15.5456Z",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99947 13.0456C11.6312 13.0456 12.954 11.7228 12.954 10.091C12.954 8.45927 11.6312 7.13647 9.99947 7.13647C8.36772 7.13647 7.04492 8.45927 7.04492 10.091C7.04492 11.7228 8.36772 13.0456 9.99947 13.0456Z",
  stroke: "#000",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.63672 3.72729L16.364 16.4546",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99945 16C6.89945 16 3.29945 12.9 1.49945 11C0.799454 10.3 0.799454 9.1 1.59945 8.4C3.39945 6.8 6.89945 4 9.99945 4C13.0995 4 16.5995 6.8 18.3995 8.5C19.0995 9.2 19.1995 10.3 18.4995 11.1C16.6995 12.9 13.0995 16 9.99945 16Z",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0008 13.2C11.7681 13.2 13.2008 11.7674 13.2008 10C13.2008 8.23274 11.7681 6.80005 10.0008 6.80005C8.23347 6.80005 6.80078 8.23274 6.80078 10C6.80078 11.7674 8.23347 13.2 10.0008 13.2Z",
  stroke: "#000",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.19922 3L16.6992 17",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}));
export { IconPasswordHide };